export enum Gender {
  Male = 'Male',
  Female = 'Female',
  Nonbinary = 'Non-binary',
  Other = 'Other',
  Unstated = 'Prefer not to say',
}

export enum IbsClassification {
  IBS_C = 'IBS-C (Constipation)',
  IBS_D = 'IBS-D (Diarrhea)',
  IBS_M = 'IBS-M (Mixed)',
}

export enum MSKPainInterferenceLevel {
  Mild = 'Mild',
  Moderate = 'Moderate',
  Severe = 'Severe',
}
